import { DependencyList, EffectCallback, useEffect, useRef } from 'react';

/**
 * Like useEffect(), but runs only on updates.
 * */
export const useUpdate = (effect: EffectCallback, deps?: DependencyList) => {
  const isInitialMount = useRef(true);

  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false;
    } else {
      return effect();
    }
  }, deps);
};
